import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { PassOfferStatus } from '../../models/Pass';
import { passMetaChipSx } from './passDetailLayout';

const statusLabel = (t: (key: string, fallback: string) => string, status: PassOfferStatus) => {
  switch (status) {
    case 'ACTIVE':
      return t('hostPasses.statusOnSale', 'Active');
    case 'INACTIVE':
      return t('hostPasses.statusNotOnSale', 'Draft');
    case 'ARCHIVED':
      return t('hostPasses.statusArchived', 'Archived');
  }
};

export interface PassOfferStatusChipProps {
  status: PassOfferStatus;
}

/** Outlined catalog-offer status chip — same size as type chips on pass surfaces. */
const PassOfferStatusChip: React.FC<PassOfferStatusChipProps> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <Chip
      label={statusLabel(t, status)}
      color={status === 'ACTIVE' ? 'success' : 'default'}
      size="small"
      variant="outlined"
      sx={passMetaChipSx}
    />
  );
};

export default PassOfferStatusChip;
